<template>
  <footer class="py-28 text-muted">© Saas1C. Все права защищены. 2019</footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>
